import React from "react";
import "./LoadingScreen.css";
import { Spin, Row } from "antd";

export default function LoadingScreen() {
  return (
    <div className="loadingScreen">
      <Row justify="center">
        <Spin size="large" />
      </Row>
    </div>
  );
};